<template>
<div>
    <div  class="buysbox" v-if="vipList.length > 0">
        <div class="buysbox-tit" style="margin: 40px 0 15px 0;">选择会员类型:</div>
        <div class="buystime clarfix">
            <!--<div class="buystit" style="">开通时长</div>-->
            <ul class="buystime-list">
                <li @click="tongSel(index,item.price,item.id)" :class="{active:wayindex == index}" v-for="(item,index) in vipList">
                    <img class="hy-ic" :src="item.icon" width="32px" height="32px">
                    <span class="newls">{{item.name}}</span>
                    <!--<div class="buys-time-year">{{item.duration}}个月</div>-->
                    <!--<div class="buys-time-money">-->
                        <!--<span class="buys-time-moneynow" style="margin-left: 0;">￥{{item.price}}</span>-->
                        <!--&lt;!&ndash;<span class="buys-time-moneyyuan">￥{{item.price * 2}}</span>&ndash;&gt;-->
                    <!--</div>-->
                    <!--<img v-if="index == 0" style="position: absolute;top: -5px;right: -5px;" src="../../assets/images/recommend_icon.png">-->
                </li>
            </ul>
        </div>
        <div class="buysbox-tit" style="margin-bottom: 20px;">会员套餐包含内容：</div>
        <!--<div style="margin:30px 0;" class="clearfix">-->
            <!--<div class="buystit">付款后将获得下列三特特权，更多服务敬请期待</div>-->
        <!--</div>-->
        <ul class="buys-xclist clearfix" v-if="vipList">
            <li>
                <img src="../../assets/images/buys-1.png" alt="">
                <div>
                    <p>最多<span>{{vipList[wayindex].recruitNum}}个</span>岗位发布上限</p>
                    <p>大量招聘需求轻松应对</p>
                </div>
            </li>
            <li>
                <img src="../../assets/images/buys-2.png" alt="">
                <div>
                    <p><span>{{vipList[wayindex].collNum}}次</span>简历免费下载次数</p>
                    <p>平台海量人才任你挑选</p>
                </div>

            </li>
            <li>
                <img src="../../assets/images/buys-3.png" alt="">
                <div>
                    <p>专业1对1客服支持</p>
                    <p>提高企业曝光率</p>
                </div>

            </li>
        </ul>
        <div style="border-top: 1px dashed #e0e0e0;margin: 40px 0 4px 0;height: 2px;"></div>
        <div style="border-top: 1px dashed #e0e0e0;height: 2px;"></div>
        <div class="buysbox-compy clearfix">
           <div class="buystit">当前企业：</div>
           <p>{{$store.state.hrinfo.companyName}}</p>
       </div>
        <div class="">
            <div class="buysbox-compy clearfix">
                <div class="buystit">有效时长：</div>
                <div style="color: #333;font-weight: bold;">{{vipList[wayindex].duration}}个月</div>
            </div>
        </div>
        <div class="buys-way">
            <div class="buystit">付款方式：</div>
            <div class="clearfix"></div>
            <ul class="charge-waylist clearfix">
                <li :class="{active:payway=='alipay'}" @click="selway('alipay')">
                    <img v-if="payway == 'alipay'" src="../../assets/images/sanjiao_small.png" class="paygou">
                    <img src="../../assets/images/alapy.png" alt="支付宝充值"></li>
                <li :class="{active:payway=='wxpay'}" @click="selway('wxpay')">
                    <img v-if="payway == 'wxpay'"  src="../../assets/images/sanjiao_small.png"  class="paygou">
                    <img src="../../assets/images/wxpay.png" alt="微信充值">
                </li>
            </ul>
        </div>
        <div class="buysmoney clearfix">
            <div class="buystit">应付</div>
            <div class="buysmoney-nums">{{ammount}}元</div>
        </div>
        <div class="buysmoney-pays" @click="pay">立即支付</div>
        <div class="base64Img-box" v-if="maskShow">
            <div class="modal-mask"></div>
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <i style="font-size: 14px;" class="iconfont icon-guanbi modal-close" @click="closeMask"></i>
                        <div class="modal-txt">{{this.payway == 'alipay' ? '支付宝支付' : '微信支付'}}</div>
                    </div>
                    <div class="modal-body" style="width: 280px;height: 250px;text-align: center;">
                        <img v-if="!chargesuc" style="display: inline-block;width: 246px;height: 246px;" class="base64Img" :src="base64Img" alt="支付二维码">
                        <img  v-else style="width: 200px;height: 200px;displaym: inline-block;margin-top: 35px;" src="//oss.51ztx.com//money_suc.gif">
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div v-else>
        <div style="text-align:center;margin-top:50px;"><img src="../../assets/images/norecord.png" alt=""></div>
    <div style="text-align:center;margin-top:30px;">暂无会员套餐信息</div>
   </div>
    </div>
    
</template>
<script>
    const  qrcode=require('qrcode-js');
    export default {
        data(){
            return{
                vipId:'',
                vipList:[],
                wayindex:0,
                payway:'alipay',
                ammount:0,
                base64Img:'',
                sn:'',
                maskShow:false,
                interval:'',
                chargesuc:false
            }
        },
        created(){
            this.getVip();
        },
        methods:{
            closeMask(){
                this.maskShow = false;
                clearInterval(this.interval);
            },
            tongSel(val,price,id){
                this.wayindex = val;
                this.ammount = price;
                this.vipId = id;
            },
            selway(val){
                this.payway = val;
            },
            getVip(){
              let url = '/wapi/company/listVip';
              this.axios.get(url).then(res => {
                  this.vipList = res.data;
                  if(res.data.length > 0){
                      this.ammount = res.data[0].price;
                  this.vipId = res.data[0].id
                  }
                  
              })
            },
            intervalResult(){
                 this.interval = setInterval(function () {
                    if(this.status*1 === 1){
                        this.chargesuc = true;
                        clearInterval(this.interval);
                        setTimeout(()=>{
                            this.maskShow = false;
                        },2500)
//                        this.maskShow = false;
//                        this.$message({
//                            type:'success',
//                            message:'购买成功'
//                        })
                    }else{
                        this.queryPayOrder();
                    }
                }.bind(this),1500);
            },
            queryPayOrder(){
                this.axios.get('/wapi/company/queryPayOrder?sn='+this.sn).then(res => {
                    this.status = res.data.status;
                })
            },
            pay(){
                if(this.wayindex == -1){
                    this.$message({
                        type:'warning',
                        message:'请选择开通时长'
                    });
                    return;
                }
                if(this.payway == 0){
                    this.$message({
                        type:'warning',
                        message:'请选择充值方式'
                    });
                    return;
                }
                //默认微信支付
                let url = `/wapi/company/getBuyVipQR4WXCode?vipId=${this.vipId}`;

                if(this.payway == 'alipay'){
                    url = `/wapi/company/getBuyVipQR4AliCode?vipId=${this.vipId}`;
                }
                this.chargesuc = false;

                this.axios.get(url).then(res => {
                    if(res.success){
                        this.maskShow = true;
                        this.sn = res.data.sn;
                        this.base64Img = qrcode.toDataURL(res.data.qrCode, 6);
                        this.intervalResult();
                    }
                });
            }
        }
    }
</script>
<style scoped lang="less">
    @import "../../assets/css/membership";
    .buysbox-tit{
        font-size: 14px;
        color: #666;
    }
    .charge-waylist{
        float: left;
        overflow: hidden;
        margin: 12px 0;
        li{
            position: relative;
            float: left;
            width: 126px;
            height:42px;
            border-radius: 5px;
            overflow: hidden;
            border:1px solid #ccc;
            cursor: pointer;
            margin-right: 20px;
            overflow: hidden;
            transition: all .3s ease;
            .paygou{
                position: absolute;
                width: 22px;
                height: 22px;
                top: -1px;
                right: -1px;
                z-index: 2;

            }
            &.active{
                border-color: @blue;

                /*background: url("../../assets/images/sanjiao_small.png") no-repeat top right;*/
            }
            &:hover{

            }
        }
        img{
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// buy.vue?14ebcc54